import { startTransition } from 'react'
import { fbt, useLocaleContext } from 'fbtee'
import { Languages } from 'lucide-react'
import { SettingsRow } from '../../components/SettingsCard'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select'
import { availableLanguages } from '../../lib/locale-context'

export function LanguageSettingsRow() {
  const { locale, setLocale } = useLocaleContext()

  function handleChange(code: string) {
    if (code === locale) return
    try {
      localStorage.setItem('beacon_locale', code)
    } catch {
      // Not remembered past this visit; the language still switches now.
    }
    startTransition(() => setLocale(code))
  }

  return (
    <SettingsRow
      icon={<Languages className="size-4" />}
      label={
        <label htmlFor="settings-language">
          {fbt('Language', 'Label for the Settings option choosing the app language')}
        </label>
      }
      trailing={
        <Select value={locale} onValueChange={handleChange}>
          <SelectTrigger id="settings-language" data-testid="settings-language" className="w-40">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Array.from(availableLanguages.entries()).map(([code, name]) => (
              <SelectItem key={code} value={code}>
                {name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      }
    />
  )
}
